export const Figure = 'figure';
